module.exports = __webpack_public_path__ + "img/double_arrow_down.a89b2e15.svg";